import { Injectable } from "@angular/core";

@Injectable()
export class ExportExcelService {
  constructor() {}

  JSONToCSVConvertor(JSONData, ReportTitle, title, ShowLabel, timeStamp) {
    // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var arrData = typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
    var CSV = "";

    // Set Report title in first row or line
    if (timeStamp) {
      CSV += title + "," + `Date: ${this.formatDate()}` + "\r\n\n";
    } else {
      CSV += title + "\r\n\n";
    }

    // This condition will generate the Label/Header
    if (ShowLabel) {
      var row = "";

      // This loop will extract the label from 1st index of on array
      for (var index in arrData[0]) {
        // Now convert each value to string and comma-seprated
        row += index + ",";
      }

      row = row.slice(0, -1);

      //append Label row with line break
      CSV += row + "\r\n";
    }

    //1st loop is to extract each row
    for (var i = 0; i < arrData.length; i++) {
      var row = "";

      //2nd loop will extract each column and convert it in string comma-seprated
      for (var index in arrData[i]) {
        row += '"' + arrData[i][index] + '",';
      }

      row.slice(0, row.length - 1);

      //add a line break after each row
      CSV += row + "\r\n";
    }

    if (CSV == "") {
      alert("Invalid data");
      return;
    }

    //Generate a file name
    var fileName = "";
    //this will remove the blank-spaces from the title and replace it with an underscore
    if (ReportTitle) {
      fileName += ReportTitle.replace(/ /g, "_");
    }

    //Initialize file format you want csv or xls
    // let uri = encodeURI('data:text/csv;charset=utf-8,' + CSV);
    let blob = new Blob([CSV], { type: "text/csv" });
    let uri = window.URL.createObjectURL(blob);

    //this trick will generate a temp <a /> tag
    var link = document.createElement("a");
    link.href = uri;

    //set the visibility hidden so it will not effect on your web-layout
    // link.style = "visibility:hidden";
    link.download = fileName + ".csv";
    //this part will append the anchor tag and remove it after automatic click
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  JSONToCSVConvertorProject(
    JSONData,
    ReportTitle,
    title,
    ShowLabel,
    timeStamp
  ) {
    // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var arrData = typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
    var CSV = "";

    // Set Report title in first row or line
    if (timeStamp) {
      CSV += title + "," + `Date: ${this.formatDate()}` + "\r\n\n";
    }

    // This condition will generate the Label/Header
    if (ShowLabel) {
      var row = "";

      // This loop will extract the label from 1st index of on array
      for (var index in arrData[0]) {
        // Now convert each value to string and comma-seprated
        row += index + ",";
      }

      row = row.slice(0, -1);

      //append Label row with line break
      CSV += row + "\r\n";
    }

    //1st loop is to extract each row
    for (var i = 0; i < arrData.length; i++) {
      var row = "";

      //2nd loop will extract each column and convert it in string comma-seprated
      for (var index in arrData[i]) {
        row += '"' + arrData[i][index] + '",';
      }

      row.slice(0, row.length - 1);

      //add a line break after each row
      CSV += row + "\r\n";
    }

    if (CSV == "") {
      alert("Invalid data");
      return;
    }

    //Generate a file name
    var fileName = "";
    //this will remove the blank-spaces from the title and replace it with an underscore
    if (ReportTitle) {
      fileName += ReportTitle.replace(/ /g, "_");
    }

    //Initialize file format you want csv or xls
    // let uri = encodeURI('data:text/csv;charset=utf-8,' + CSV);
    let blob = new Blob([CSV], { type: "text/csv" });
    let uri = window.URL.createObjectURL(blob);

    //this trick will generate a temp <a /> tag
    var link = document.createElement("a");
    link.href = uri;

    //set the visibility hidden so it will not effect on your web-layout
    // link.style = "visibility:hidden";
    link.download = fileName + ".csv";
    //this part will append the anchor tag and remove it after automatic click
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  formatDate() {
    let date = new Date();
    let hours = date.getHours();
    let minutes: any = date.getMinutes();
    let ampm = hours >= 12 ? "pm" : "am";
    let curMonth = date.getMonth() + 1;
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let strTime = hours + ":" + minutes + " " + ampm;
    return (
      date.getDate() +
      "-" +
      curMonth +
      "-" +
      date.getFullYear() +
      "  " +
      strTime
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/services/export-excel.service.ts